import $ from "jquery";

export default class Matomo {
    constructor() {
        $('[data-event]').on('click', (e) => {
            let event = e.currentTarget.dataset['event'];
            let page = e.currentTarget.dataset['url'];
            let action = !!e.currentTarget.innerText ? e.currentTarget.innerText : event;
            let title = e.currentTarget.dataset['title'] ? e.currentTarget.dataset['title'] : action;
            try {
                if (!!_paq) {
                    !!_paq?.push && _paq.push(['trackEvent', event, title, page]);
                }
            } catch (err) {
            }
        });
    }
}